import { StyleSheet, Platform } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { isIPhoneDeviceWithNotch } from '@vfgroup-oneplatform/foundation/Utils/Platform';

const isIPhoneWithNotch = isIPhoneDeviceWithNotch();

export default StyleSheet.create({
  divider: theme => ({
    borderBottomColor: theme.colors.fillColor,
    borderBottomWidth: 1,
    marginHorizontal: -16,
  }),
  footerDescriptionStyle: {
    marginTop: 19,
    marginBottom: -1,
    lineHeight: 18.7,
    fontFamily: Fonts.type.VFFont,
    fontSize: 14,
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: Colors.DARK_GREY,
  },
  extrasModalHeaderStyle: {
    marginTop: 12,
  },
  paymentTypeSectionContainerStyle: {
    marginTop: 5,
  },
  paymentAmountContainerStyle: {
    marginTop: 15,
    marginBottom: 5,
  },
  doneLoadingMainTitleStyle: theme => ({
    color: theme.colors.textColorThree,
  }),
  doneLoadingSubTitleStyle: theme => ({
    fontSize: 18.7,
    color: theme.colors.textColorThree,
  }),
  loadingMessageTextStyle: {
    marginTop: 10,
    fontSize: 20,
  },
  loadingLottieViewStyle: {
    width: 180,
    height: 180,
  },
  btnsContainerStyle: {
    marginBottom: Platform.OS === 'android' || isIPhoneWithNotch ? 5 : 3,
  },
});
